import { Directive, HostListener, Output,EventEmitter } from '@angular/core';


@Directive({
  selector: '[appDragDrop]'
})
export class DragDropDirective {
  fileOver = false;
  constructor() { }
  @Output() fileDropped = new EventEmitter([] as any);

  //DragOver Listener.
  @HostListener('dragover',['$event']) onDragOver(evt:any){
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = true;
    console.log('Drag Over');
  }

  //DragLeave Listener.
  @HostListener('dragleave',['$event']) onDragLeave(evt:any){
    evt.preventDefault();
    evt.stopPropagation();
    console.log('Drag Leave');

  }

  //Drop Listener.
  @HostListener('drop',['$event']) onDrop(evt:any){
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    const files = evt.dataTransfer.files;
    if(files.length>0){
      this.fileDropped.emit(files);
      console.log(`You Dropped ${files.length} files.`);
    }
  }

}
